// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lr-textcenter {
  text-align: center;
}

.lr-center {
  display: flex;
  flex-direction: row;
  justify-content: center;
  justify-items: center;
  align-self: center;
  justify-self: center;
}

.lr-pad {
  padding-left: 20px;
  padding-right: 20px;
}

.lr-heading {
  margin-bottom: 26px;
}

.lr-intro {
  margin-bottom: 27px;
}

.lr-list {
  padding-left: 0;
  margin-bottom: 34px;
  margin-right: 25px;
}

.lr-list li {
  list-style: none;
  display: -webkit-inline-box;
  margin-bottom: 8px;
}

.lr-list li img {
  padding-right: 10px;
}

.lr-btn {
  margin-bottom: 32px;
}

.lr-back-link {
  display: block;
  text-align: center;
  margin-bottom: 55px;
}

.lr-success-icon {
  height: 50.5px;
  width: 50.5px
}

.lr-button-separation {
  margin-bottom: 32px;
}

.olr-icon-checkmark {
  background-image: url('icon-checkmark.svg');
  width: 24px;
  height: 20px;
  background-repeat: no-repeat;
  background-size: contain;
  display: block;
}

.olr-icon-success_stroke {
  background-image: url('success_stroke_32.svg');
  width: 50px;
  height: 50px;
  background-repeat: no-repeat;
  background-size: contain;
  margin: 0 auto;
  display: block;
}

@media(min-width: 768px) {
  .lr-pad {
    padding-left: 0;
    padding-right: 0;
  }

  .lr-heading {
    margin-bottom: 19px;
  }

  .lr-intro {
    margin-bottom: 29px;
  }

  .lr-list {
    margin-bottom: 56px;
  }
}

@media(min-width: 1200px) {
  .lr-heading {
    margin-bottom: 23px;
  }

  .lr-intro {
    font-weight: normal;
    font-size: 25px;
    line-height: 38px;
    color: #000;
    margin-bottom: 32px;
  }

  .lr-list {
    margin-bottom: 34px;
  }
}

.olr-nowrap {
  white-space: nowrap;
}

.lr-repair-box {
  padding: 60px;
  border: solid 1px #cbcbcb;
  position: relative;
  padding-bottom: 80px;
}

.lr-repair-box .-oneX-icon-container {
  position: absolute;
  top: 60px;
  right: 60px;
}

.lr-button-right {
  float: right;
}

.lr-padding-bottom {
  padding-bottom: 20px;
}

.olr-merna03-red {
  color: #D62311;
}

.olr-charcoal02 {
  color: #403C3C
}

.olr-icon-phone-position {
  position: absolute;
  bottom: 0;
  right: 0;
}

.olr-relative-position {
  position: relative;
}

ul {
  padding-left: 15px;
}

#toRepair {
  margin-bottom: 4%;
}

#toClaimsHub {
  margin-top: 7%;
}

.modal-content{
  border:0px;
  text-align: center;
  color: #36454F;
}

.modal-text{
font-weight: 200;
color: #808080;
text-align: justify;
}

.modal {
  position:fixed;
  top:0;
  left:0;
  width:200%;
  height:100%;
  background: rgba(0,0,0,0.5);
  display:flex;
  justify-content: center;
  align-items:center;
    
  }

  .popup-content{
    background:white;
    padding:20px;
    border-radius:1px;
    text-align:center;
    width:250px;
    position:fixed;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
  }

.lr-link {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  justify-content: flex-end;
  align-items: center;
}


.lr-end{
  text-align:end;
  background: white;
}

.modal-button{
  text-align:end;
  color: #d62311;
  font-weight: bold;
  border:0;
  background: white;
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/confirmation/save-confirmation/save-confirmation.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2CAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,8CAAgE;EAChE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;AACA,gBAAgB;AAChB,cAAc;AACd,mBAAmB;AACnB;;AAEA;EACE,cAAc;EACd,KAAK;EACL,MAAM;EACN,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;;EAElB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,OAAO;IACP,QAAQ;IACR,8BAA8B;EAChC;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;;AAGA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,QAAQ;EACR,iBAAiB;AACnB","sourcesContent":[".lr-textcenter {\n  text-align: center;\n}\n\n.lr-center {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  justify-items: center;\n  align-self: center;\n  justify-self: center;\n}\n\n.lr-pad {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.lr-heading {\n  margin-bottom: 26px;\n}\n\n.lr-intro {\n  margin-bottom: 27px;\n}\n\n.lr-list {\n  padding-left: 0;\n  margin-bottom: 34px;\n  margin-right: 25px;\n}\n\n.lr-list li {\n  list-style: none;\n  display: -webkit-inline-box;\n  margin-bottom: 8px;\n}\n\n.lr-list li img {\n  padding-right: 10px;\n}\n\n.lr-btn {\n  margin-bottom: 32px;\n}\n\n.lr-back-link {\n  display: block;\n  text-align: center;\n  margin-bottom: 55px;\n}\n\n.lr-success-icon {\n  height: 50.5px;\n  width: 50.5px\n}\n\n.lr-button-separation {\n  margin-bottom: 32px;\n}\n\n.olr-icon-checkmark {\n  background-image: url(../../../assets/img/icon-checkmark.svg);\n  width: 24px;\n  height: 20px;\n  background-repeat: no-repeat;\n  background-size: contain;\n  display: block;\n}\n\n.olr-icon-success_stroke {\n  background-image: url(../../../assets/img/success_stroke_32.svg);\n  width: 50px;\n  height: 50px;\n  background-repeat: no-repeat;\n  background-size: contain;\n  margin: 0 auto;\n  display: block;\n}\n\n@media(min-width: 768px) {\n  .lr-pad {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .lr-heading {\n    margin-bottom: 19px;\n  }\n\n  .lr-intro {\n    margin-bottom: 29px;\n  }\n\n  .lr-list {\n    margin-bottom: 56px;\n  }\n}\n\n@media(min-width: 1200px) {\n  .lr-heading {\n    margin-bottom: 23px;\n  }\n\n  .lr-intro {\n    font-weight: normal;\n    font-size: 25px;\n    line-height: 38px;\n    color: #000;\n    margin-bottom: 32px;\n  }\n\n  .lr-list {\n    margin-bottom: 34px;\n  }\n}\n\n.olr-nowrap {\n  white-space: nowrap;\n}\n\n.lr-repair-box {\n  padding: 60px;\n  border: solid 1px #cbcbcb;\n  position: relative;\n  padding-bottom: 80px;\n}\n\n.lr-repair-box .-oneX-icon-container {\n  position: absolute;\n  top: 60px;\n  right: 60px;\n}\n\n.lr-button-right {\n  float: right;\n}\n\n.lr-padding-bottom {\n  padding-bottom: 20px;\n}\n\n.olr-merna03-red {\n  color: #D62311;\n}\n\n.olr-charcoal02 {\n  color: #403C3C\n}\n\n.olr-icon-phone-position {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n\n.olr-relative-position {\n  position: relative;\n}\n\nul {\n  padding-left: 15px;\n}\n\n#toRepair {\n  margin-bottom: 4%;\n}\n\n#toClaimsHub {\n  margin-top: 7%;\n}\n\n.modal-content{\n  border:0px;\n  text-align: center;\n  color: #36454F;\n}\n\n.modal-text{\nfont-weight: 200;\ncolor: #808080;\ntext-align: justify;\n}\n\n.modal {\n  position:fixed;\n  top:0;\n  left:0;\n  width:200%;\n  height:100%;\n  background: rgba(0,0,0,0.5);\n  display:flex;\n  justify-content: center;\n  align-items:center;\n    \n  }\n\n  .popup-content{\n    background:white;\n    padding:20px;\n    border-radius:1px;\n    text-align:center;\n    width:250px;\n    position:fixed;\n    top:50%;\n    left:50%;\n    transform:translate(-50%,-50%);\n  }\n\n.lr-link {\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n\n.lr-end{\n  text-align:end;\n  background: white;\n}\n\n.modal-button{\n  text-align:end;\n  color: #d62311;\n  font-weight: bold;\n  border:0;\n  background: white;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
